import { useMatches } from 'react-router'

export function useRouteBotId() {
  const matches = useMatches()

  return matches[matches.length - 1]?.params.botId
}
